module.exports = __webpack_public_path__ + "img/7.ec136f21.jpg";